import { useCancelUpgradeRequest } from '../../hooks/useBilling';
import type { UpgradeOption } from '../../types';

interface Props {
  option: UpgradeOption | undefined;
  onUpgradeClick: (option: UpgradeOption) => void;
}

export default function UpgradePlanAction({ option, onUpgradeClick }: Props) {
  const cancelRequest = useCancelUpgradeRequest();

  if (!option) return null;

  const pending = option.pending_request;
  if (pending) {
    return (
      <span className="inline-flex items-center gap-1.5">
        <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          Upgrade requested ({pending.requested_plan})
        </span>
        <button
          onClick={() => {
            if (window.confirm('Cancel your pending upgrade request?')) {
              cancelRequest.mutate(pending.id);
            }
          }}
          disabled={cancelRequest.isPending}
          className="text-xs text-gray-500 hover:text-gray-700 underline disabled:opacity-50 transition-colors"
        >
          {cancelRequest.isPending ? 'Cancelling...' : 'Cancel request'}
        </button>
        {cancelRequest.isError && (
          <span className="text-xs text-red-600">
            {cancelRequest.error instanceof Error
              ? cancelRequest.error.message
              : 'Failed to cancel'}
          </span>
        )}
      </span>
    );
  }

  if (option.eligible_plans.length === 0) return null;

  return (
    <button
      onClick={() => onUpgradeClick(option)}
      title="Upgrade Plan"
      className="px-2 py-0.5 text-xs font-medium text-blue-600 border border-blue-300 rounded hover:bg-blue-50 transition-colors"
    >
      Upgrade Plan
    </button>
  );
}
